/** Width of the sidebar */
export const SIDENAV_WIDTH = 254

/** Default URL for the Paxton logo icon (square version) */
export const PAXTON_LOGO_ICON_URL = '/images/paxton-web-square-120.png'
